export default "__VITE_ASSET__C78kgyDS__"